import React, { useEffect } from "react";
import cal_link_maker from "../../Functions/cal_link_maker";
import { Backtotop } from "../../widgets";
import EventShowcase from "../../containers/EventShowcase/EventShowcase";
import "./Freshers_magazine.css";
import { freshers_events, freshers_magazine } from "../../constants/freshers_asso";
import { Timeline } from "../../components";
import { FaComputer } from "react-icons/fa6";

import {
  freshers_asso_heroimage_carousalinfo,
  freshersmenu,
  freshers_workshops
} from "../../constants/freshers_asso";

import { Heroimagecarousal, RadialMenu } from "../../components";
import { Deptvision, Deptmission, Underline, Floatinmenu } from "../../widgets";

const Freshers_magazine = () => {

  useEffect(() => {
    document.title = "ACCET-Freshers' Association";
  }, []);

  return (
    <div>
      <Backtotop />

      <div className="freshersdept">

        <Heroimagecarousal
          key={freshers_asso_heroimage_carousalinfo.id}
          title={freshers_asso_heroimage_carousalinfo.title}
          img_list={freshers_asso_heroimage_carousalinfo.img_list}

        />
  <RadialMenu menu_links={freshersmenu} />
        
        

        <div className="section_padding">
  <Underline heading="Freshers' Magazine" />
</div>

        <div className="freshers_magazine_container">
          <div className="freshers_magazine_reports">
 <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={freshersmenu} />
        </div>
            {freshers_magazine.map((item) => (
              <Timeline
                key={item.id}
                head={item.title}
                house={item.house}
                pdf={item.pdf}
              />
            ))}

          </div>
        </div>

      </div>
    </div>
  );
};

export default Freshers_magazine;